import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.test');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-page-test',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.test/view.scss */
/* src/app/page.test/view.scss: no such file or directory */`],
})
export class PageTestComponent implements OnInit {

    public async ngOnInit() {
        const script = document.createElement("script");
        script.src = "/assets/chatbot.js?top=auto&amp;right=20px&amp;bottom=90px";
        document.body.appendChild(script)
    }
}

export default PageTestComponent;